<template>
  <div>
    <div
      :class="`matchmaking-widget ${state ? state : 'no-searching'} ${hasAccepted ? 'has-accepted' : ''}`"
      @click="togglePanel"
    >
      <div v-if="state == '' && playersSearching > 0">
        <h6>
          <strong>{{playersSearching}}</strong> players
          <br>buscando ranked
        </h6>
      </div>

      <div v-if="state == 'searching'">
        <div class="sp sp-hydrogen"></div>
        <h6>
          <strong>{{playersSearching}}</strong> players
          <br>buscando ranked
        </h6>
        <span>clique para cancelar</span>
      </div>

      <div v-if="state == 'preready'">
        <h5 v-if="!hasAccepted">partida encontrada</h5>
        <p v-if="!hasAccepted">confirme sua presença clicando abaixo</p>

        <p class="countDownTimer" v-if="timeLeftToReady >= 0">
          <span>{{timeLeftToReady}}</span> segundos restantes
        </p>

        <div v-if="!hasAccepted" class="not-accepted">
          <b-btn size="lg" block variant="success" @click.stop.prevent="acceptMatch">ESTOU PRONTO</b-btn>
          <small>não confirmando você receberá um ban de 10 minutos</small>
        </div>

        <div v-else class="accepted">
          <h5>você foi confirmado! aguardando outros players</h5>
        </div>
      </div>
    </div>
    <!-- !closed -->

    <div ref="matchmakingContainer" class="matchmaking-container" v-if="!closed">
      <b-modal
        ref="mmModal"
        id="mmModal"
        :hide-footer="true"
        :hide-header="true"
        size="md"
        v-model="modalShow"
        body-class="modal-matchmaking"
        @hidden="modalClosed"
      >
        <b-container fluid>
          <div class="content-area">
            <h2>Ranked Competitiva</h2>

            <div class="maps">
              <p v-for="map in maps" :key="map">{{map}}</p>
            </div>

            <div v-if="false && clubs.length > 0" class="clubs-container">
              <b-form-group label="Com qual club quer jogar?">
                <b-form-radio-group
                  v-model="club_id"
                  :options="clubOptions"
                  name="radios-stacked"
                  stacked
                ></b-form-radio-group>
              </b-form-group>
            </div>

            <h6>O mapa será vetado no servidor</h6>

            <div class="checklist">
              <h6>Antes de jogar, leia e confirme</h6>
              <b-button
                block
                :pressed.sync="check1"
                variant="dark"
              >Vou jogar até o final e respeitar a todos</b-button>

              <b-button block :pressed.sync="check2" variant="dark">
                Já estou com o
                anti-cheat instalado e rodando
                <small>Ready. Start the game.</small>
              </b-button>
            </div>

            <div class="search-button" v-if="check1 && check2">
              <b-button
                v-on:click.stop.prevent="searchMatch"
                variant="success"
                size="lg"
              >Procurar partida agora</b-button>
            </div>
            <!-- </div> -->
          </div>
        </b-container>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "Matchmaking",
  props: {
    msg: String
  },
  computed: {
  },
  data: function() {
    return {
      closed: true,
      modalShow: true,
      subscription: Object,
      maps: [
        "de_inferno",
        "de_dust2",
        "de_mirage",
        "de_cache",
        "de_overpass",
        "de_train",
        "de_nuke",
        "de_vertigo"
      ],
      check1: false,
      check2: false,
      state: "",
      timeLeftToReady: 0,
      hasAccepted: false,
      playersSearching: 0,
      demoInterval: Object,
      leftInterval: Object,
      club_id: null,
      clubs: [],
      clubOptions: []
    };
  },
  methods: {
    togglePanel() {
      if (this.hasAccepted || this.state == "preready") return;
      else {
        if (this.closed && this.state == "searching") {
          this.state = "";
          this.subscription.cancelSearch();
        } else if (this.closed) {
          this.closed = false;
          this.check1 = false;
          this.check2 = false;
        } else {
          this.closed = true;
        }
      }
    },
    modalClosed() {
      this.togglePanel();
      this.modalShow = true;
    },
    acceptMatch() {
      this.subscription.acceptMatch();
      this.hasAccepted = true;
    },
    searchMatch() {
      this.closed = true;

      var self = this;
      this.state = "searching";

      // console.log(this.subscription);
      this.subscription.searchMatch();
    },
    initialize: function() {
      var self = this;

      this.subscription = this.$cable.subscriptions.create(
        { channel: "MatchmakingChannel" },
        {
          searchMatch: function(data) {
            return this.perform("search_match", {});
          },
          cancelSearch: function(data) {
            return this.perform("cancel_search", {});
          },
          acceptMatch: function(data) {
            return this.perform("accept_match", {});
          },
          received: function(data) {
            if (data.action == "searching_update") {
              self.playersSearching = data.players_searching_count;
            } else if (data.action == "preready") {
              if (data.users.includes(self.currentUser.id)) {
                self.state = "preready";
                var audio = new Audio("/match-found.mp3");
                audio.volume = 0.25;
                audio.play();
                self.timeLeftToReady = 30;
                self.hasAccepted = false;

                self.leftInterval = setInterval(() => {
                  self.timeLeftToReady--;
                }, 1000);
              }
            } else if (data.action == "match_canceled") {
              if (data.users.includes(self.currentUser.id)) {
                clearInterval(self.leftInterval);
                self.hasAccepted = false;
                self.timeLeftToReady = 0;

                self.$notify({
                  group: "all",
                  title:
                    "Um dos players não aceitou a partida e foi banido. Já te colocamos novamente na busca :)",
                  type: "success",
                  duration: 7000
                });
                // self.subscription.unsubscribe();
                self.state = "";
                self.searchMatch();
              }
            } else if (data.action == "banned") {
              if (data.users.includes(self.currentUser.id)) {
                clearInterval(self.leftInterval);
                self.hasAccepted = false;
                self.timeLeftToReady = 0;

                self.$notify({
                  group: "all",
                  title:
                    "Você não aceitou uma partida portanto está banido por 5 minutos da Ranked",
                  type: "error",
                  duration: -1000
                });
                // self.subscription.unsubscribe();
                self.state = "";
              }
            } else if (data.action == "match_found") {
              if (data.users.includes(self.currentUser.id)) {
                clearInterval(self.leftInterval);
                self.hasAccepted = false;
                self.timeLeftToReady = 0;

                self.state = "match-found";
                self.$router.push({
                  name: "RoomSingle",
                  params: { id: data.lobby_id }
                });
                // self.playersSearching = 0;
                // self.subscription.unsubscribe();
              }
            } else {
              console.log(data);
            }
          }
        }
      );

      window.addEventListener(
        "beforeunload",
        function(event) {
          if (self.subscription.hasOwnProperty("unsubscribe")) {
            self.subscription.unsubscribe();
          }
        },
        false
      );

      // if (this.isLoggedIn) {
      //   this.$http.get("pages/my_account.json").then(response => {
      //     this.clubs = response.data.clubs;

      //     var clubOptions = response.data.clubs.map(club => {
      //       return { text: club.name, value: club.id };
      //     });
      //     clubOptions.push({
      //       text: "jogar com todos do QUEOTA.club",
      //       value: null
      //     });
      //     this.clubOptions = clubOptions;
      //   });
      // }
    }
  },
  mounted() {
    this.initialize();
  }
};
</script>

<style lang="sass">
.matchmaking-container
  #mmModal
    background: rgba(black, .8) !important
    .modal-content
      background: transparent
    .modal-matchmaking
      background: transparent
      border: 0
      color: white
  
      .content-area
        font-family: 'Rajdhani', sans-serif
        margin-top: 40px
        h2 
          color: rgba(white, .2)
        legend,
        h6
          font-weight: bold
          font-size: 22px
          &:last-of-type
            margin-top: 30px
        .custom-radio
          &:not(:last-child)
            margin-bottom: 6px
          label
            font-family: monospace
            font-weight: normal
            font-size: 16px
            color: rgba(white, .4)


        .checklist
          .btn
            margin-bottom: 5px
            line-height: 100%
            text-align: left
            background: transparent
            border: 0
            color: rgba(white, .4)
            border-right: 4px solid rgba(white, .2)
            position: relative

            font-size: 32px
            font-weight: normal

            small
              position: absolute
              bottom: -20px
              font-size: 11px
              font-weight: bold
              opacity: 0
              transition: all .3s ease
              display: block

            a
              color: rgba(white, .4)
              font-weight: normal

            &:before
              content: '1'
              color: rgba(255, 255, 255, .4)
              font-family: 'Oswald', monospace
              font-size: 9px
              position: absolute
              top: 1px
              left: 1px
            
            &:last-child:before
              content: '2'

            &:active,
            &.active,
            &:focus
              outline: 0
              box-shadow: none
            
            &:hover
              border-right: 4px solid white
              font-weight: bold
              color: white
              a
                color: white
              small
                opacity: 1
            
            &.active
              border-right: 4px solid #28a745
              font-weight: bold
              color: #28a745
              a
                color: #28a745
              small
                opacity: 1
              //  65%, rgba(5,51,5,0.8) 96%)
              // color: background: linear-gradient(0deg, rgba(4,164,4,.9) 65%, rgba(5,51,5,0.8) 96%)

        .maps
          display: none
          p
            margin: 0
            color: rgba(0, 255, 0, .4)
        
        .search-button
          text-align: center
          margin-top: 30px
          
.matchmaking-widget
  position: fixed
  bottom: 0
  left: 0px
  font-size: 9px
  padding: 4px 4px 0 6px
  background: rgba(0, 0, 0, .2)
  z-index: 5
  transition: all 1s
  cursor: pointer

  &.has-accepted
    background: green !important
  // ,.preready
  &:not(.searching):not(.preready):hover
    transform: scale(1.1)

  .sp
    width: 32px
    height: 32px
    clear: both
    margin: 20px auto
  .sp-hydrogen
    position: relative
    border: 1px #fff solid
    border-radius: 50%
    -webkit-animation: spHydro 0.6s infinite linear
    animation: spHydro 0.6s infinite linear
  .sp-hydrogen:before, .sp-hydrogen:after
    content: ''
    position: absolute
    width: 10px
    height: 10px
    background-color: #fff
    border-radius: 50%
  .sp-hydrogen:before
    top: calc( 50% - 5px )
    left: calc( 50% - 5px )
  .sp-hydrogen:after
    top: -1px
    left: -1px
  @-webkit-keyframes spHydro
    from
      -webkit-transform: rotate(0deg)
    to
      -webkit-transform: rotate(359deg)
  @keyframes spHydro
    from
      transform: rotate(0deg)
    to
      transform: rotate(359deg)

  &.no-searching
    background: linear-gradient(5deg, rgba(164,4,4,1.8673844537815126) 35%, rgba(51,5,5,0.8869922969187675) 66%)
    color: white
    // padding: 10px
    opacity: .77
    &:hover
      opacity: 1
    h6
      margin: 0
      strong
        font-size: 14px
    span
      font-size: 11px

  &.searching
    background: linear-gradient(5deg, rgba(164,4,4,1.8673844537815126) 35%, rgba(51,5,5,0.8869922969187675) 66%)
    color: white
    padding: 10px
    opacity: .77
    &:hover
      opacity: 1
    h6
      margin: 0
      strong
        font-size: 14px
    span
      font-size: 11px
  
  &.preready
    padding: 30px
    opacity: 1
    background: linear-gradient(5deg, rgba(164,4,4,1.8673844537815126) 35%, rgba(51,5,5,0.8869922969187675) 66%)
    color: white
    text-align: center

    h5
      text-transform: uppercase
    
    p
      font-size: 16px
      span
        font-size: 24px
        font-weight: bold

    small
      display: block
      margin-top: 10px
      font-size: 12px
      font-weight: bold
    
    .not-accepted
      text-align: center
    
    .accepted
      h5
        margin-bottom: 0

</style>
